import { inject, type InjectionKey } from 'vue'

export function useInjectOrThrow<T>(key: InjectionKey<T>): T {
  const value = inject(key)
  if (value === undefined) {
    throw new Error(`No provider found for injection key: ${key.toString()}`)
  }
  return value
}
